import { useEffect, useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import { apiURL } from '../../../utilities/URLs'
import { CustomerApplication } from '../../../utilities/CustomerData'

import 'react-phone-input-2/lib/style.css'

export function ApplicationStep1({ _customerApplication, createApplication, phoneInUse, emailInUse, handleApplicationStep1 }) {
  const customerApplication = new CustomerApplication(_customerApplication)

  const [firstName, setFirstName] = useState(customerApplication.firstName)
  const [lastName, setLastName] = useState(customerApplication.lastName)
  const [email, setEmail] = useState(customerApplication.email)
  const [confirmEmail, setConfirmEmail] = useState(customerApplication.email)
  const [phone, setPhone] = useState(customerApplication.phone)
  const [confirmPhone, setConfirmPhone] = useState(customerApplication.phone)
  const [referralCode, setReferralCode] = useState('')
  const [checkingReferralCode, setCheckingReferralCode] = useState(false)
  const [referralCodeError, setReferralCodeError] = useState('')
  const [appliedReferralCode, setAppliedReferralCode] = useState('')
  const [errors, setErrors] = useState({})

  const handleCheckReferralCode = async () => {
    setCheckingReferralCode(true)

    const referralCodeResponse = await fetch(`${apiURL}/api/checkApplicationReferralCode?referralCode=${encodeURIComponent(referralCode)}`)
    const referralCodeData = await referralCodeResponse.json()
    setCheckingReferralCode(false)
    if (referralCodeData.response.error)
      setReferralCodeError(referralCodeData.response.error)
    else
      setAppliedReferralCode(referralCode)
  }

  const handleCheckApplicationStep1 = async () => {
    const newErrors = {}

    if (!firstName) newErrors.firstName = 'First name is required'
    if (!lastName) newErrors.lastName = 'Last name is required'
    if (!email) newErrors.email = 'Email is required'
    if (!confirmEmail) newErrors.confirmEmail = 'Please confirm your email'
    if (email !== confirmEmail) newErrors.confirmEmail = 'Emails do not match'
    if (!phone) newErrors.phone = 'Phone number is required'
    if (phone.length < 11) newErrors.phone = 'Phone number is not in the correct format'
    if (!confirmPhone) newErrors.confirmPhone = 'Please confirm phone number'
    if (phone !== confirmPhone) newErrors.confirmPhone = 'Phone numbers do not match'

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    handleApplicationStep1(firstName.trim(), lastName.trim(), email.trim().toLocaleLowerCase(), phone, appliedReferralCode)
  }

  useEffect(() => {
    const newErrors = {}
    if (phoneInUse) newErrors.phone = 'Phone is already in use'
    if (emailInUse) newErrors.email = 'Email is already in use'

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }
  }, [phoneInUse, emailInUse])

  return (
    <div className='w-full h-full flex flex-col items-center lg:justify-center mt-4 overflow-y-auto'>
      <p className='mb-4 max-sm:text-center'>Please enter the following information as it appears on your tax return.</p>
      <div className='grid lg:grid-cols-2 gap-x-4 lg:w-3/4 w-11/12 gap-y-5'>
        <div className='relative mb-4'>
          <p className='absolute text-sm bg-white left-3 top-[-5px] max-sm:text-[0.7rem] max-sm:top-[-4px]'>First Name</p>
          <input
            type='text'
            name='firstName'
            placeholder='Enter Your First Name'
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            className={`mt-1 p-3 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 
                  ${errors.firstName ? 'border-red-500' : 'focus:ring-indigo-300'}`}
          />
          {errors.firstName && <p className='text-red-500 text-xs mt-1'>{errors.firstName}</p>}
        </div>
        <div className='relative mb-4'>
          <p className='absolute bg-white left-3 top-[-5px] text-sm max-sm:text-[0.7rem] max-sm:top-[-4px]'>Last Name</p>
          <input
            type='text'
            name='lastName'
            placeholder='Enter Your Last Name'
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            className={`mt-1 p-3 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 
                  ${errors.lastName ? 'border-red-500' : 'focus:ring-indigo-300'}`}
          />
          {errors.lastName && <p className='text-red-500 text-xs mt-1'>{errors.lastName}</p>}
        </div>
        <div className='relative mb-4'>
          <p className='absolute bg-white left-3 top-[-5px] text-sm'>Email</p>
          <input
            type='text'
            name='email'
            placeholder='Enter Your Email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={`mt-1 p-3 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 
                  ${errors.email ? 'border-red-500' : 'focus:ring-indigo-300'}`}
          />
          {errors.email && <p className='text-red-500 text-xs mt-1'>{errors.email}</p>}
        </div>
        <div className='relative mb-4'>
          <p className='absolute bg-white left-3 top-[-5px] text-sm'>Confirm Email</p>
          <input
            type='text'
            name='confirmEmail'
            placeholder='Confirm Your Email'
            value={confirmEmail}
            onChange={(e) => setConfirmEmail(e.target.value)}
            className={`mt-1 p-3 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 
                  ${errors.confirmEmail ? 'border-red-500' : 'focus:ring-indigo-300'}`}
          />
          {errors.confirmEmail && <p className='text-red-500 text-xs mt-1'>{errors.confirmEmail}</p>}
        </div>
        <div className='w-full mb-4'>
          <p className='text-sm'>Phone</p>
          <PhoneInput
            country={'us'}
            disableDropdown
            countryCodeEditable={false}
            value={phone}
            onChange={phone => setPhone(phone)}
            inputStyle={{ width: '100%', borderColor: errors.phone ? 'red' : '' }}
          />
          {errors.phone && <p className='text-red-500 text-xs mt-1'>{errors.phone}</p>}
        </div>
        <div className='w-full'>
          <p className='text-sm'>Confirm Phone</p>
          <PhoneInput
            country={'us'}
            disableDropdown
            countryCodeEditable={false}
            value={confirmPhone}
            onChange={phone => setConfirmPhone(phone)}
            inputStyle={{ width: '100%', borderColor: errors.confirmPhone ? 'red' : '' }}
          />
          {errors.confirmPhone && <p className='text-red-500 text-xs mt-1'>{errors.confirmPhone}</p>}
        </div>
      </div>
      <button
        disabled={createApplication}
        onClick={handleCheckApplicationStep1}
        className={`px-8 py-2 mt-10 mb-4 text-white rounded max-sm:mb-4 ${createApplication ? 'bg-gray-400 cursor-not-allowed' : 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200'}`}>
        Next
      </button>
      {createApplication && (
        <div className='flex flex-row items-center justify-center gap-2'>
          <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
          <p>Starting Application...</p>
        </div>
      )}
    </div>
  )
}

/**
 * {!appliedReferralCode ? (
          <div className='relative w-full flex flex-col justify-end'>
            <div className='absolute bg-white left-3 -top-3 flex items-end'>
              <p className='text-sm'>Customer Referral Code</p>
              <div className='relative ml-1 group'>
                <span className='text-sm cursor-pointer'>&#x3F;</span>
                <div className='absolute opacity-0 group-hover:opacity-100 bg-gray-700 text-white text-xs rounded py-1 px-2 w-48 -top-8 left-2 z-10 transition-opacity duration-200 ease-in-out'>
                  A referral code is a 6 digit code that you can apply that will allow you and the referee to get off $50 on your processing fee.
                </div>
              </div>
            </div>
            <div className='w-full flex flex-col'>
              <div className='flex'>
                <input
                  type='text'
                  name='referralCode'
                  placeholder='Referral Code'
                  value={referralCode}
                  onChange={(e) => setReferralCode(e.target.value)}
                  className={`p-3 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 
                        ${errors.referralCode ? 'border-red-500' : 'focus:ring-indigo-300'}`}
                />
                <button
                  disabled={!referralCode || checkingReferralCode}
                  onClick={handleCheckReferralCode}
                  className={`${referralCode && !checkingReferralCode ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-500 cursor-not-allowed'} ml-2 px-4 py-2 text-white rounded-md shadow-sm focus:outline-none focus:ring focus:ring-indigo-300`}
                >
                  Apply
                </button>
              </div>
              {checkingReferralCode && (
                <div className='flex flex-row items-center justify-start gap-2'>
                  <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
                  <p>Checking Referral Code...</p>
                </div>
              )}
            </div>
            {referralCodeError && <p className='text-red-500 text-xs mt-1'>{referralCodeError}</p>}
          </div>
        ) : (
          <div className='bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4' role='alert'>
            <p className='font-bold'>Referral Code Applied!</p>
            <p>The code <span className='font-mono font-bold'>{appliedReferralCode}</span> has been successfully applied.</p>
          </div>
        )}
 */